import { setActiveMenuItem } from "./menuActions";

export const goto = (history, redirectTo) => dispatch => {
  history.push(redirectTo);
  dispatch(setActiveMenuItem(redirectTo));
};
